// eslint-disable-next-line import/prefer-default-export
export const assetsOrder = [
  'ONE',
  'WONE',
  'FTM',
  'WFTM',
  'MATIC',
  'WMATIC',
  'BUSD',
  'DAI',
  'UNIDAI',
  'GUSD',
  'GHST',
  'SUSD',
  'TUSD',
  'USDC',
  'UNIUSDC',
  'USDP',
  'USDT',
  'UST',
  'UNIUSDT',
  'EURS',
  'BAL',
  'ETH',
  'WETH',
  'SETH',
  'STETH',
  'SUSHI',
  'LINK',
  'MKR',
  'RAI',
  'UNI',
  'WBTC',
  'XSUSHI',
  'YFI',
  'FEI',
  'FRAX',
  'AAVE',
  'AMPL',
  'BAT',
  'CRV',
  'DPI',
  'ENJ',
  'ENS',
  'KNC',
  'LEND',
  'MANA',
  'PAX',
  'REN',
  'RENFIL',
  'REP',
  'SNX',
  'ZRX',

  'UNIDAIUSDC',
  'UNIUSDCDAI',
  'UNIWBTCUSDC',
  'UNIDAIETH',
  'UNIDAIWETH',
  'UNIUSDCETH',
  'UNIUSDCWETH',
  'UNIAAVEWETH',
  'UNIBATWETH',
  'UNICRVWETH',
  'UNISETHETH',
  'UNILENDETH',
  'UNILINKETH',
  'UNILINKWETH',
  'UNIMKRETH',
  'UNIMKRWETH',
  'UNIRENWETH',
  'UNISNXWETH',
  'UNIUNIWETH',
  'UNIWBTCWETH',
  'UNIYFIWETH',

  'GUNIDAIUSDC',
  'GUNIUSDCUSDT',

  'BPTBALWETH',
  'BPTDPIWBTCWETH',
  'BPTLINKWETH',
  'BPTMKRWETH',
  'BPTSNXWETH',
  'BPTUSDCWETH',
  'BPTWBTCWETH',
  'BPTWETHDAI',
  'BPTWETHUSDT',
  'BPTYFIWETH',
];
